import React, { FC } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';
import { AdditionalSelectField } from '../AdditionalSelectField';

type ProductCategorySectionProps = AdditionalFieldsSectionProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    'handleSelectChange' | 'handleSelectClear' | 'handleBooleanChange'
  >;

export const ProductCategorySection: FC<ProductCategorySectionProps> = ({
  values,
  isFieldsDisabled,
  handleSelectChange,
  handleSelectClear,
  handleBooleanChange,
}) => (
  <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
    <AdditionalSelectField
      label={ADDITIONAL_FIELDS_META.product.label}
      value={values.product}
      options={ADDITIONAL_FIELDS_META.product.enumValues ?? []}
      disabled={isFieldsDisabled}
      onChange={handleSelectChange('product')}
      onClear={handleSelectClear('product')}
    />
    <AdditionalSelectField
      label={ADDITIONAL_FIELDS_META.category.label}
      value={values.category}
      options={ADDITIONAL_FIELDS_META.category.enumValues ?? []}
      disabled={isFieldsDisabled}
      onChange={handleSelectChange('category')}
      onClear={handleSelectClear('category')}
    />
    {(
      [
        'hasContainer',
        'hasFunnelByContainer',
        'hasQualityAudiencePurchase',
      ] as const
    ).map((key) => (
      <FormControlLabel
        key={key}
        sx={{ alignSelf: 'flex-end' }}
        control={
          <Checkbox
            sx={{ py: 0 }}
            size="small"
            checked={Boolean(values[key])}
            disabled={isFieldsDisabled}
            onChange={handleBooleanChange(key)}
          />
        }
        label={ADDITIONAL_FIELDS_META[key].label}
      />
    ))}
  </Box>
);
